
namespace Sintra {

    export interface MediaQueryWatcherEvent {
        matches: boolean;
        media: string;
        //mediaQueryList: MediaQueryList;
    }

    export class MediaQueryWatcher {

        private _breakpoints: Array<string>;
        private _matches: TypedValueObject<string, MediaQueryList>;

        constructor() {
            this._breakpoints = [];
            this._matches = {};
        }


        public addBreakpointHandler(breakpoint: string, changeHandler: (e: MediaQueryWatcherEvent) => void, triggerOnInit = true) {

            let mediaQuery: MediaQueryList;
            if (this._breakpoints.indexOf(breakpoint) >= 0) {
                mediaQuery = this._matches[breakpoint];
            }
            else {
                this._breakpoints.push(breakpoint);
                mediaQuery = window.matchMedia(breakpoint);
            }

            if ('addEventListener' in mediaQuery) {
                mediaQuery.addEventListener("change", changeHandler);
            }
            else {
                // NOTE: use addListener for backward compatibility
                mediaQuery.addListener(changeHandler);
            }

            if (triggerOnInit) {
                changeHandler({
                    matches: mediaQuery.matches,
                    media: mediaQuery.media
                });
            }

            return mediaQuery;
        }

        public removeBreakpointHandler(breakpoint: string, changeHandler: (e: MediaQueryWatcherEvent) => void) {
            if (this._breakpoints.indexOf(breakpoint) < 0) {
                return false;
            }
            const mediaQuery = this._matches[breakpoint];
            if ('addEventListener' in mediaQuery) {
                mediaQuery.removeEventListener("change", changeHandler);
            }
            else {
                // NOTE: use addListener for backward compatibility
                mediaQuery.removeListener(changeHandler);
            }
            return true;
        }
    }
}